import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalComponent } from '../../shared/modal/modal.component';
import { GameModalService } from './game-modal.service';
import { UserService } from '../../shared/services/user.service';
import {NavigationService} from '../../shared/services/navigation.service';

@Component({
  selector: 'app-game-screen',
  standalone: true,
  imports: [CommonModule, NgIf, ModalComponent],
  templateUrl: 'game-page.component.html',
  styleUrls: ['game-page.component.scss']
})
export class GamePageComponent implements OnInit, OnDestroy {
  gameName = '';
  gameImage = '';
  gameUrl: SafeResourceUrl | null = null;
  gameInProgress = false;
  modalText = '';
  isModalReadyToPlayOpen = false;
  isMobile = false;
  height: string | number = 702;

  private path: string = '';
  private points: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private gameModalService: GameModalService,
    private userService: UserService,
    private navigationService: NavigationService,
  ) {}

  get isModalOpen() {
    return this.gameModalService.isOpen();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkMobileScreen();

    this.height = this.isMobile ? '100%' : 702;
  }

  ngOnInit(): void {
    this.checkMobileScreen();
    this.height = this.isMobile ? 459 : 702;

    this.route.queryParams.subscribe(params => {
      this.path = params['path'];
      this.points = Number(params['points'] || 0);
      this.gameName = params['name'] || 'Unknown Game';
      let imgPath = params['image'];

      if(this.isMobile && imgPath) {
        const basePath = params['image'];
        imgPath = basePath.replace('games', 'games/mobile');
      }
      console.log(imgPath)
      this.gameImage = imgPath || 'assets/images/placeholder.png';

      this.startGame()
    });
  }

  ngOnDestroy() {
    this.gameInProgress = false;
  }

  checkMobileScreen() {
    this.isMobile = window.innerWidth <= 768;
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent) {
    if (this.gameInProgress) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  startGame() {
    this.userService.usePointsForGame(this.points).subscribe({
      next: () => {
        this.isModalReadyToPlayOpen = false;
        this.gameInProgress = true;
        this.gameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          `assets/games/${this.path}/index.html`
        );
      },
      error: () => {
        this.router.navigate(['/shop']);
      }
    });
  }

  goBack() {
    this.gameModalService.open().subscribe(confirmed => {
      if (confirmed) {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  resumeGame() {
    this.gameModalService.cancel();
  }

  quiteGame() {
    this.gameInProgress = false;
    this.gameModalService.confirm();
  }

  restartGame() {
    this.modalText = `Starting this game will cost you ${this.points} points. Do you want to continue?`
    this.isModalReadyToPlayOpen = true;
  }

  closeReadyToPlayModal() {
    this.isModalReadyToPlayOpen = false;
  }
}
